// rootReducer.js
import { combineReducers } from "@reduxjs/toolkit";
import { SweatReducer } from "./Feature/UrlSlice";
import { EmailReducer } from "./Feature/EmailSlice";
import { categoryReducer } from "./Feature/CategorySlice";

const rootReducer = combineReducers({
  UrlData: SweatReducer,
  emailData: EmailReducer,
  Categories: categoryReducer,
});

export default rootReducer;
